module.exports = __webpack_public_path__ + "static/media/ken.03882f62.png";